import { Option } from '@renderer/@types/types'
import { useQuiz } from '@renderer/lib/useQuiz'
import { motion } from 'motion/react'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

const speed = 0.2
const bounce = 0.2
const btnTransition = {
  scale: { type: 'spring', visualDuration: speed, bounce: bounce },
  opacity: { type: 'spring', visualDuration: speed, bounce: bounce },
  backgroundColor: { type: 'spring', visualDuration: speed, bounce: bounce },
  color: { type: 'spring', visualDuration: speed, bounce: bounce }
}

const AnswerOption = ({ data }: { data: Option }) => {
  const { selectAnswer, currentIndex, currentAnswersIds, isAnswered, currentQuestion } = useQuiz()

  const isMultiple = useMemo(() => currentQuestion?.type === 'multiple', [currentQuestion])
  const { t } = useTranslation('translation', { keyPrefix: 'quiz' })
  const handleAnswer = (id: number) => {
    selectAnswer(id)
  }

  const isSelected = useMemo(
    () => currentAnswersIds.includes(data.id),
    [isAnswered, currentAnswersIds, data.id]
  )


  const variants = {
    single: {
      scale: 1,
      transform: 'scale(1)',
      transition: btnTransition,
      opacity: isAnswered && !isSelected ? 0.3 : 1,
      border: '4px solid var(--primary)',
      backgroundColor:
        isAnswered && !isSelected
          ? 'oklch(0.98 0.05 96.49)'
          : isSelected
            ? 'var(--primary)'
            : 'oklch(1 0 0)',
      // color: isSelected ? 'oklch(1 0 0)' : 'var(--primary)'
    },
    multiple: {
      scale: 1,
      transform: 'scale(1)',
      border: '4px solid var(--primary)',
      transition: btnTransition,
      backgroundColor: isSelected ? 'var(--primary)' : 'oklch(1 0 0)',
      // textColor: isSelected ? 'oklch(1 0 0)' : 'var(--primary)',
      // color: isSelected ? 'oklch(1 0 0)' : 'var(--primary)'
    }
  }

  return (
    <motion.div
      key={`question-${currentIndex}-option-${data.id}`}
      initial={{ scale: 0, opacity: 1, backgroundColor: 'oklch(1 0 0)' }}
      variants={variants}
      animate={isMultiple ? 'multiple' : 'single'}
      onClick={() => handleAnswer(data.id)}
      className="text-primary flex items-center justify-center cursor-pointer p-3 min-h-[3rem] [@media(max-height:1100px)]:p-2 [@media(max-height:1100px)]:min-h-[2.5rem] [@media(min-height:1101px)]:p-4 [@media(min-height:1101px)]:min-h-[3.5rem]"
      whileTap={{ transform: 'scale(1.2)' }}
    >
      <span
        className={`font-bold text-center leading-tight text-xl [@media(max-height:1100px)]:text-base [@media(min-height:1101px)]:text-2xl ${isSelected ? 'text-white' : 'text-primary'}`}
      >
        {t(`${currentQuestion.id}.options.${data.id}` as any) as string}
      </span>
    </motion.div>
  )
}

export default AnswerOption
